import Paper from '@/components/Paper'
import {
    DataTableCustomized,
    FilterBar,
} from '@/components/ui/data-table-customized'
import { useCustomerServices } from '@/modules/Customer/hooks/use-customer-services'
import { Typogaphy } from 'vnetwork-ui'

/**
 * POC Services Table
 * Trial/POC services (is_poc: true)
 */
export const PocServices = () => {
    const {
        services,
        pagination,
        stateComponent,
        isFetching,
        params,
        control,
        setFilter,
        searchInputProps,
        columns,
        filterItems,
        // expandedRowRender,
        // rowExpandable,
        handleSortChange,
        handlePageChange,
        handlePageSizeChange,
        t,
    } = useCustomerServices({ isPoc: true })

    return (
        <Paper>
            <div className="mb-2">
                <Typogaphy className="font-medium text-primary">
                    {t('poc-services')}
                </Typogaphy>
            </div>

            <FilterBar
                control={control}
                setFilter={setFilter}
                items={filterItems}
                hideSearch
            />

            {stateComponent || (
                <DataTableCustomized
                    columns={columns}
                    rows={services}
                    rowKey={(row) => String(row?.service_id)}
                    size="small"
                    resizable
                    loading={!services.length && !pagination}
                    isFetching={isFetching}
                    emptyMessage={t('no-services', {
                        defaultValue: 'No services found',
                    })}
                    sorting={{
                        sortBy: params.sort_by,
                        sortOrder: params.sort_order,
                        onSortChange: handleSortChange,
                    }}
                    // TODO: Temporarily disabled expanded row
                    // expandable={{
                    //     expandedRowRender,
                    //     rowExpandable,
                    // }}
                    pagination={{
                        page: params.page || 1,
                        pageSize: params.page_size || 10,
                        total: pagination?.total || 0,
                        onPageChange: handlePageChange,
                        onPageSizeChange: handlePageSizeChange,
                        pageSizeOptions: [10, 20, 50, 100],
                    }}
                    toolbar={{
                        search: {
                            ...searchInputProps,
                            placeholder: t('search-service', {
                                defaultValue: 'Search services...',
                            }),
                        },
                        settings: {
                            show: true,
                            storageKey: 'customer-poc-services',
                        },
                    }}
                />
            )}
        </Paper>
    )
}
